import React from "react";
import {
  Route,
  FileCheck2,
  Users,
  ClipboardList,
  BellRing,
  ShieldCheck,
} from "lucide-react";

export default function WhyAttendSection() {
  const seminarPoints = [
    {
      title: "Counselling Roadmap",
      description:
        "Understand the complete NEET counselling process step-by-step, from registration to final seat allotment.",
      icon: Route,
    },
    {
      title: "Document Readiness",
      description:
        "Learn which documents are required and how to avoid common mistakes during verification and reporting.",
      icon: FileCheck2,
    },
    {
      title: "Personalised Strategy",
      description:
        "Know how your score, category, quota, state preference, and budget affect your admission chances.",
      icon: Users,
    },
    {
      title: "Choice Filling Guidance",
      description:
        "Learn how to create a smarter choice list to improve clarity, order, and college selection strategy.",
      icon: ClipboardList,
    },
    {
      title: "Important Updates",
      description:
        "Get clarity on counselling rounds, deadlines, reporting windows, and key admission announcements.",
      icon: BellRing,
    },
    {
      title: "Low Score Admission Plan",
      description:
        "Understand practical options to secure a medical seat even with a lower NEET score using the right approach.",
      icon: ShieldCheck,
    },
  ];

  return (
    <section className="relative overflow-hidden bg-[#fffaf6] py-16 sm:py-20 lg:py-24">
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          {/* <span className="inline-flex rounded-full bg-[#fff4ec] px-4 py-2 text-xs font-semibold uppercase tracking-wide text-[#ff9245]">
            Free NEET Seminar
          </span> */}

          <h2 className="mt-4 text-2xl sm:text-3xl font-bold text-center capitalize text-[#0F172A]">
            What You Will Get Inside This <span className="text-[#ff9245]">Seminar</span>
          </h2>

          <p className="mx-auto mt-4 w-full text-sm sm:text-lg text-slate-600">
            Understand counselling strategy, avoid mistakes, and improve your chances of getting a better medical college.
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:mt-14 lg:grid-cols-3">
          {seminarPoints.map((item) => {
            const Icon = item.icon;

            return (
              <div
                key={item.title}
                className="group flex h-full flex-col rounded-2xl border border-[#f2dfd2] bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-[#ff9245]/50 hover:shadow-lg"
              >
                <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#fff4ec] transition duration-300 group-hover:scale-105">
                  <Icon className="h-6 w-6 text-[#ff9245]" />
                </div>

                <h3 className="min-h-[56px] text-center text-lg font-semibold leading-7 text-[#0F172A]">
                  {item.title}
                </h3>

                <p className="mt-3 text-center text-sm leading-6 text-slate-600">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* <div className="mt-10 flex justify-center">
          <a
            href="#register"
            className="rounded-full bg-[#ff9245] px-7 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-[#f97316] hover:shadow-lg"
          >
            Register for Free Seminar
          </a>
        </div> */}
      </div>
    </section>
  );
}
